import { useQuery } from 'react-query'

import { SpendingCardKeys } from '@webapp/modules/spending-cards'
import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { AdminCard } from '@webapp/modules/spending-cards/entities/AdminCard'

type UseQueryAdminCardReturn = {
  adminCard: Nullable<AdminCard>
  refetch: () => void
  isFetching: boolean
}

export const useQueryAdminCard = ({
  externalId,
  enabled = true,
  onError,
}: {
  externalId: string
  enabled?: boolean
  onError?: (error: Error) => void
}): UseQueryAdminCardReturn => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: [...SpendingCardKeys.GET_CARD_ADMIN, externalId],
    queryFn: () => cardRepository.getAdminCard({ externalId }),
    enabled,
    onError,
  })

  return {
    adminCard: data?.data ? new AdminCard(data.data) : null,
    refetch,
    isFetching,
  }
}
